import React from 'react'
import { useGuide } from '../../hook/useGuide'
import Joyride from "react-joyride";
import { useGuideSteps } from '../../hook/useGuideSteps';

const joyrideStyles = {
    options: {
        arrowColor: '#f5f6f8', /* App.css: --color-grey-1 */
        backgroundColor: '#f5f6f8', /* App.css: --color-grey-1 */
        overlayColor: '#444c52', /* App.css: --color-grey-5 */
        primaryColor: '#0292EF', /* App.css: --color-blue-4 */
        textColor: '#02111B', /* App.css: --color-blue-10 */
        width: undefined,
        zIndex: 10000,
    },
};

// Component to show "Question Icon Button" and let the users take a guide tour for know the features
export const ButtonHelp = ( {page, context} ) => {

    const {stepsValues} = useGuideSteps(page, context);
    
    // Hook to handle all Joyride Component functionalities
    const { steps, handleClickStart, handleJoyrideCallback, run, setRun, stepIndex, setStepIndex } = useGuide(stepsValues, false);

    return (
        <>
            <div iconclass="snx-icon-link-blue" className="snx-btn-action btn btn-primary">
                <i onClick={ handleClickStart } className="material-icons snx-icon-link md-24">help</i>
            </div>
            <Joyride
                run={run}
                callback={handleJoyrideCallback}
                steps={steps}
                stepIndex={stepIndex}
                disableBeacon={false}
                disableScrollParentFix={true}
                disableOverlayClose={true}
                continuous={true}
                showProgress={true}
                showSkipButton={true}
                // scrollToSteps={true}
                styles={joyrideStyles}
            />
        </>
    )
}

export default ButtonHelp;